export default __webpack_public_path__ + "static/media/Ballroll_00060.32084b84.png";